import createLucideIcon from '../createLucideIcon';

const Laptop2 = createLucideIcon('Laptop2', [
  [
    'rect',
    {
      width: '18',
      height: '12',
      x: '3',
      y: '4',
      rx: '2',
      ry: '2',
      key: '1qhy41',
    },
  ],
  ['line', { x1: '2', x2: '22', y1: '20', y2: '20', key: 'ni3hll' }],
]);

export default Laptop2;
